var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPinGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6699 10.6104L15.272 15.0083C15.6103 15.963 15.7532 17.5568 14.2797 19.5189C14.1753 19.6565 14.043 19.7706 13.8914 19.8535C13.7398 19.9364 13.5724 19.9863 13.4001 20H13.3174C12.9988 19.9986 12.6936 19.8717 12.468 19.6467L8.84443 16.0232L6.26587 18.6092C6.15092 18.7204 5.99727 18.7825 5.83736 18.7825C5.67746 18.7825 5.52381 18.7204 5.40886 18.6092C5.29592 18.4952 5.23257 18.3412 5.23257 18.1807C5.23257 18.0202 5.29592 17.8662 5.40886 17.7522L7.99494 15.1737L4.35638 11.5351C4.23568 11.4162 4.14164 11.2729 4.08051 11.1149C4.01937 10.9569 3.99254 10.7877 4.00178 10.6185C4.01102 10.4493 4.05613 10.284 4.13411 10.1335C4.2121 9.9831 4.32118 9.85096 4.45411 9.74589C6.3636 8.20477 8.19039 8.51299 8.99479 8.76108L13.4077 4.3482C13.6341 4.12508 13.9393 4 14.2572 4C14.5751 4 14.8802 4.12508 15.1067 4.3482L19.6699 8.91143C19.7822 9.02258 19.8713 9.15488 19.9321 9.3007C19.993 9.44651 20.0243 9.60293 20.0243 9.76093C20.0243 9.91892 19.993 10.0753 19.9321 10.2212C19.8713 10.367 19.7822 10.4993 19.6699 10.6104Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinGray);
export default __webpack_public_path__ + "static/media/icon-pin-gray.417c8a63f00730dfeae90386f3206041.svg";
export { ForwardRef as ReactComponent };